import successAnimation from '@/assets/lottie/success.json';
import { useAdminContext } from '@/contexts/AdminContext';
import Lottie from 'lottie-react';
import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

interface OnboardingSuccessModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const OnboardingSuccessModal: React.FC<OnboardingSuccessModalProps> = ({isOpen, onClose}) => {
    const hasShownToastRef = useRef(false);
    const {modal} = useAdminContext();

    useEffect(() => {
        if (isOpen && !hasShownToastRef.current) {
            // Show toast only once when modal opens
            hasShownToastRef.current = true;
            modal.openModal('welcome')
            // Auto close after animation completes
            const closeTimer = setTimeout(() => {
                onClose();
                // Reset ref after closing to prevent re-opening on re-render
                hasShownToastRef.current = false;
            }, 3000);

            return () => clearTimeout(closeTimer);
        }
    }, [isOpen, modal, onClose]);

    if (!isOpen) return null;

    return createPortal(
        <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-transparent pointer-events-none">
            <div className="w-full h-full flex items-center justify-center pointer-events-none">
                <div className="w-[600px] h-[600px]">
                    <Lottie animationData={successAnimation} loop={false} />
                </div>
            </div>
        </div>,
        document.body
    );
};
